import React, { Component } from 'react'
import SettingsMenu from './SettingsMenu'
import SettingBooking from './SettingBooking'
import NotificationsMenu from './NotificationsMenu'
import { checkTranslation, conditionalWidth, imageAddress, translate } from '../../utils/useful'
import ShoppingCartMenu from '../../windows/Applets/ShoppingCartMenu'
import SettingsCommerceUserMenu from './SettingsCommerceUserMenu'
import ButtonAnimated from '../buttons/ButtonAnimated'

export default class CAHeaderInfo extends Component {

    render() {

        let title = this.props.config?.title ?? this.props.page?.title
        if (title == '') {
            title = null
        }
        let info = this.props.config?.info ?? this.props.page?.info
        if (info == '') {
            info = null
        }

        let type = this.props.config?.type ?? this.props.applet?.type

        if (!type && Array.isArray(this.props.applet?.features)) {
            type = this.props.applet.features[0]
        }

        let colors = this.props.colors


        return (

            <div className='flexcc w-100 p-2'>

                <div className={" " + conditionalWidth(this.props.width, { xs: 'd-flex flex-column w-100', sm: 'flexcb w-100' })}>


                    <div className='flexc w-100'>
                        {this.props.config?.backAction && (
                            <button className='flexc' onClick={() => this.props.config?.backAction()}>
                                <img width={30} src="/assets/icons/back-white.svg" />
                            </button>

                        )}

                        {this.props.config?.headerIdentityComponent ? (
                            <div className='flexc'>

                                <div className=' flexc' style={{ justifyContent: conditionalWidth(this.props.width, { xs: 'flex-end', sm: 'start' }) }}>
                                    {this.props.config?.headerIdentityComponent()}
                                </div>
                            </div>
                        ) : (
                            <div className={"w-100 " + conditionalWidth(this.props.width, { xs: 'flexc', sm: 'flexc' })} style={{ position: 'sticky', top: 0 }}>
                                <div className='flexc'>


                                </div>
                                <div className=''>

                                    {(info) ? (
                                        <div className=''>
                                            <p onClick={() => this.props.goToHub()} className='mt-0 text-normal  text-semibold' style={{ whiteSpace: "nowrap", color: colors?.textColor }} > {checkTranslation(info)} </p>
                                            <div className='flexc pt-1'>
                                                <p onClick={() => this.props.goToHub()} className=' cursor-pointer mt-0  text-semibold' style={{ whiteSpace: "nowrap", color: colors?.textColor, fontSize: 13, fontWeight: "400" }} > {checkTranslation(title)}</p>

                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            {this.props.applet && (
                                                <p className={"m-0  mb-0  flexc " + (title ? ('text-smaller opacity-7 ') : ('text-normal text-semibold'))} style={{ maxWidth: 450, whiteSpace: "nowrap", color: colors?.textColor }}>{checkTranslation(this.props.applet?.name)}{!title ? '' : ' / ' + this.props.applet?.hub?.fullname}</p>
                                            )}
                                            {(title) && (
                                                <div className='flexc'>
                                                    <p onClick={() => this.props.goToHub()} className='mt-0 text-normal text-semibold' style={{ whiteSpace: "nowrap", color: colors?.textColor }} >{checkTranslation(title)}</p>

                                                </div>
                                            )}
                                            {(!title) && (
                                                <p onClick={() => this.props.goToHub()} className=' cursor-pointer mt-0 text-smaller  opacity-7' style={{ whiteSpace: "nowrap", color: colors?.textColor }} >{this.props.applet?.hub?.fullname}</p>
                                            )}
                                        </>
                                    )}


                                </div>
                            </div>


                        )}
                    </div>


                    {/* <div>
                        <ButtonAnimated
                            iconwidth='24px'
                            onClick={() => this.props.config?.next()}
                            title={translate(this.props.config.btnText)}
                            icon='/assets/icons/angle-right-white2.svg'
                            textColor={'#222'}
                            invert={!this.props.colors?.iconInvert}
                            bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                        />
                    </div> */}



                </div>



                {this.props.config?.topHeaderComponent && (
                    <div className=' flexc' style={{ justifyContent: conditionalWidth(this.props.width, { xs: 'flex-end', sm: 'start' }) }}>
                        {this.props.config?.topHeaderComponent()}
                    </div>
                )}
            </div>

        )
    }
}
